import React from 'react';

export default function IndexSectionCallToAction12() {
    return (
        <React.Fragment>
            <>
                <section className="py-20 bg-yellow-50">
  <div className="container mx-auto px-4">
    <div className="flex justify-center mb-6">
      <div className="bg-yellow-100 py-1 px-2 text-xs font-bold inline-block">New feature</div>
    </div>
    <h1 className="font-heading text-center text-4xl lg:text-5xl font-bold max-w-2xl lg:max-w-5xl mx-auto mb-4">Share with your friends in real time</h1>
    <p className="text-gray-600 text-center max-w-xl mx-auto mb-6">Do you like to show to your friends where you have been eating?</p>
    <div className="relative" style={{height: 512}}>
      <img className="absolute hidden lg:block bottom-0 left-0 w-80 h-80 -ml-40" src="cronos-assets/elements/big-warning-green-dark.svg" alt />
      <img className="absolute hidden lg:block top-0 right-0 w-80 h-80 -mr-64" src="cronos-assets/elements/warning-group-square.svg" alt />
      <img className="relative w-full object-cover h-full" src="https://images.unsplash.com/photo-1482148829819-e32810d7e13a?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzMzIzMzB8MHwxfHNlYXJjaHwyOHx8c29jaWFsJTIwZm9vZCUyMHxlbnwwfHx8fDE3NDg4OTg5MDB8MA&ixlib=rb-4.1.0&q=85&w=1920" alt />
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

